module.exports = __webpack_public_path__ + "static/media/overpass-mono-bold.6cb4a77b.woff2";